import { ValuesModel } from './values.model';

export class GoodwillModel {
  visible = false;
  sum = 0;

  condition_security_compensation: ValuesModel | null = null;
  energy_cost_surcharge: ValuesModel | null = null;
  manufacturer_reference_compensation: ValuesModel | null = null;
  processing_fee_credits: ValuesModel | null = null;
  fee_reimbursement: ValuesModel | null = null;
  subsidies: ValuesModel | null = null;
  goodwill_credit: ValuesModel | null = null;
  discount_credit: ValuesModel | null = null;
  promotional_bonus: ValuesModel | null = null;
  goodwill_returns: ValuesModel | null = null;
  discount_charge: ValuesModel | null = null;
  performance_contribution: ValuesModel | null = null;
  minimum_wage_contribution: ValuesModel | null = null;
  target_revenue_compensation: ValuesModel | null = null;

  readonly sort = [
    'condition_security_compensation',
    'energy_cost_surcharge',
    'manufacturer_reference_compensation',
    'processing_fee_credits',
    'fee_reimbursement',
    'subsidies',
    'goodwill_credit',
    'discount_credit',
    'promotional_bonus',
    'goodwill_returns',
    'discount_charge',
    'performance_contribution',
    'minimum_wage_contribution',
    'target_revenue_compensation'
  ] as const;

  private readonly labelMap: Record<string, string> = {
    condition_security_compensation: 'Konditionssicherungsausgleich (KSA)',
    energy_cost_surcharge: 'Energiekostenzuschlag (EK)',
    manufacturer_reference_compensation: 'Zielpackungsausgleich (ZPA)',
    processing_fee_credits: 'Bearbeitungsgebühr Warengutschriften (AB)',
    fee_reimbursement: 'Gebührenerstattung (GE)',
    subsidies: 'Subventionen (SU)',
    goodwill_credit: 'Kulanzgutschrift (KG)',
    discount_credit: 'Rabattgutschrift (RG)',
    promotional_bonus: 'Aktionsprämie (AP)',
    goodwill_returns: 'Kulanzretouren (KR)',
    discount_charge: 'Rabattbelastung (RB)',
    performance_contribution: 'Leistungsbeitrag (LB)',
    minimum_wage_contribution: 'Mindestlohnbeitrag (MLB)',
    target_revenue_compensation: 'Zielumsatzvergütung (ZV)'
  };

  constructor(obj?: Record<string, any>) {
    if (!obj) return;

    for (const [key, label] of Object.entries(this.labelMap)) {
      if (obj[key]) {
        (this as any)[key] = new ValuesModel({ label, value: obj[key] });
      }
    }

    this.sum = obj['sum'] ?? 0;
    this.visible = obj['visible'] ?? false;
  }
}
